import React from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import langLayouts from './LangLayouts';
export default class Search extends React.Component {

    constructor(props) {
		super(props);
		this.queryInput = React.createRef();
		this.state = {
			layoutName : 'default',
			lang : 'ru'
		};
		this.isKiosk = false;
		this.keyboard = React.createRef();
		let queryString = window.location.search;
		if (queryString=='?kiosk=1') this.isKiosk = true;
		this.onKeyPress = this.onKeyPress.bind(this);
		this.setKeyboardValue = this.setKeyboardValue.bind(this);
		this.langs = langLayouts;
    }
	
	
	getLang() {
		return this.langs[this.state.lang];
	}
	
	onKeyPress(button) {
		if (button === "{shift}" || button === "{lock}") this.handleShift();
		if (button === "{lang_en}") this.setState({lang: 'en'});
		if (button === "{lang_ru}") this.setState({lang: 'ru'});
	}
	
	handleShift() {
		let currentLayout = this.keyboard.current.options.layoutName;
		let shiftToggle = currentLayout === "default" ? "shift" : "default";
		this.keyboard.current.setOptions({
			layoutName: shiftToggle
		});
	}

	setKeyboardValue() {
		if (this.props.query.length===0 && this.keyboard.current) this.keyboard.current.setInput('');
	}
	
	render() {
		let {layoutName} = this.state;
		let keysDisplay = {
			"{enter}": "Enter",
			"{escape}": "esc ⎋",
			"{tab}": "tab ⇥",
			"{bksp}": "⌫",
			"{lock}": "caps lock ⇪",
			"{shift}": "⇧",
			"{controlleft}": "ctrl ⌃",
			"{controlright}": "ctrl ⌃",
			"{altleft}": "alt ⌥",
			"{altright}": "alt ⌥",
			"{space}": "&nbsp;&nbsp;&nbsp;",
			"{lang_en}" : "Английский",
			"{lang_ru}" : "Русский"
		}
		
		
		return (
			<React.Fragment>
				<div class="search-input-holder">
					<input id="queryInput" value={this.props.query} onChange={e => this.props.setQuery(e.target.value)} class="search-form_input" placeholder="Поиск" type="text" ref={this.queryInput} onFocus={this.setKeyboardValue}/>
					<button class="search-form_button" type="submit">Поиск</button>
				</div>
				{this.isKiosk &&
					<div className={'keyboardContainer confirm'}>
							<Keyboard
								keyboardRef={r => (this.keyboard.current = r)}
								inputName={'queryInput'}
								layoutName={layoutName}
								onChange={val => this.props.setQuery(val,this.queryInput)}
								display={keysDisplay}
								//debug={true}
								layout={this.getLang()}
								onKeyPress={this.onKeyPress}
								mergeDisplay={true}
							/>
					</div>
				}
			</React.Fragment>
		);
	}

}